import script from "./FinancePrelevementsWalletComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinancePrelevementsWalletComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__